import { Tab } from '@material-ui/core'
import { ContainerPage, TitlePage } from 'components'
import { ChangeEvent, useMemo, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import CardContainerOrders from './components/CardContainerOrders'
import CardHistory from './components/CardHistory'
import { ContainerHeader, TabContainer } from './styles'
import CardContainerOrdersFinance from './components/CardContainerPendingOrders'

const Invoices = () => {
  const [tab, setTab] = useState(0)

  const onChangeTab = (event: ChangeEvent<{}>, newValue: number) => {
    setTab(newValue)
  }

  return (
    <>
      <ContainerPage>
        <ContainerHeader component="header">
          <TitlePage>Financeiro dos pedidos</TitlePage>
        </ContainerHeader>
        <TabContainer value={tab} onChange={onChangeTab} centered tab={tab}>
          <Tab label="Sem nota fiscal" />
          <Tab label="Liberados sem nota fiscal" />
          <Tab label="Pagamentos pendentes" />
        </TabContainer>
        {tab === 0 && <CardContainerOrders />}
        {tab === 1 && <CardHistory />}
        {tab === 2 && <CardContainerOrdersFinance />}
      </ContainerPage>
    </>
  )
}

export default Invoices
